import fire from '../fire';

const deleteRes = async(emnekode, resId) => {
    const db = fire.firestore()
    await db.collection('emner').doc(emnekode).collection("resources").doc(resId).delete()
    console.log("Slettet ressurs:", resId)
}

export default deleteRes;
